import { createFeatureSelector } from '@ngrx/store';
import { CreateNewState } from '../models/create-new.model';
import { RedeemRulesSearchState } from '../models/redeem-rules.model';
import { CreateNewReducer } from './create-new.reducer';
import { RedeemRulesSearchReducer } from './search.reducer';

export const featureRedeemRulesName = 'RedeemRules';

export interface DragonflyRedeemRulesState {
  search: RedeemRulesSearchState;
  createNew: CreateNewState;
}

export const moduleRedeemRulesReducers = {
  search: RedeemRulesSearchReducer,
  createNew: CreateNewReducer,
};

export const getDragonflyRedeemRulesState =
  createFeatureSelector<DragonflyRedeemRulesState>(featureRedeemRulesName);
